export const Constants = {
    Meta: "meta",
    AdcConfig: "ADC",
    Network: "Network",
    AdvancedOptions: "advancedOptions"
}

export const VARIABLES = {
    userSession: 'ilensDatalogger',
};